module.exports = __webpack_public_path__ + "img/tools_paytrend2.d4774264.png";